/* eslint-env browser */

/**
 * GA Events
 *
 * Adds labels to the datalayer to be picked up by google analytics
 */

function pushToDataLayer(dataToPush) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataToPush);
}

function fireGAEvent(custom_label) {
    this.pushToDataLayer({
        event: "custom_event",
        custom_category: "Button",
        custom_action: "Click",
        custom_label: custom_label,
        custom_value: null,
        enhanced_conversion_data: null,
    });
}
